<div class="export-panel">
  <!-- Title bar -->
  <div class="export-title">
    <span>{{ mode === 'pdf' ? 'PDF report' : 'CSV file' }}</span>
  </div>

  <!-- Main content -->
  <div class="export-content">
    <!-- PDF mode: template selector + section toggles -->
    <ng-container *ngIf="mode === 'pdf'">
      <div class="template-row">
        <span class="template-label">Report template</span>
        <select class="template-select" disabled>
          <option>VeriCure PDF Template</option>
        </select>
      </div>

      <div class="section-list">
        <div class="section-item" *ngFor="let section of sections">
          <label class="checkbox-label">
            <input
              type="checkbox"
              [(ngModel)]="flags[section.key]"
            />
            <span class="checkmark" [class.checked]="flags[section.key]"></span>
            <span class="section-name">{{ section.label }}</span>
          </label>
        </div>
      </div>
    </ng-container>

    <!-- CSV mode: empty content area -->
    <ng-container *ngIf="mode === 'csv'">
      <div class="csv-info">
        <p>Export all temperature measurements as a semicolon-delimited CSV file.</p>
        <p class="csv-detail">Includes project metadata, measurement configuration, and a full data grid with timestamps and per-position temperatures.</p>
      </div>
    </ng-container>

    <!-- Error message -->
    <div class="error-msg" *ngIf="errorMessage">{{ errorMessage }}</div>
  </div>

  <!-- Bottom action bar -->
  <div class="export-actions">
    <button class="btn-back" (click)="goBack()" [disabled]="isGenerating" title="Cancel">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M12 4L6 10L12 16" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <button
      class="btn-confirm"
      (click)="generate()"
      [disabled]="isGenerating"
      title="Generate report"
    >
      <span *ngIf="!isGenerating">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M4 10L8 14L16 6" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span *ngIf="isGenerating" class="spinner"></span>
    </button>
  </div>
</div>
